import { Text, TextProps } from '@dapperlabs/core-fe';

type PillProps = {
  layout: 'portrait' | 'landscape';
  text: string;
} & TextProps;

/**
 * Pill component
 *
 * @param props
 * @param props.text required text displayed in pill
 * @param props.layout required layout for pill placement depending on portrait or landscape
 */
export const Pill = ({ text, layout, ...rest }: PillProps): JSX.Element => (
  <Text
    position='absolute'
    zIndex='1'
    top={layout === 'portrait' ? '4' : '2'}
    left={layout === 'portrait' ? '4' : '2'}
    px={1.5}
    py={0.5}
    color='black'
    fontFamily='mono'
    fontSize='xs'
    borderRadius={5}
    bgColor='cyan.400'
    {...rest}
  >
    {text}
  </Text>
);
